<div class="timer" [ngStyle]="{'font-size': fontSize, 'color': color}">
    <span id="days"> {{daysToDay}} </span> Day(s)
    <span id="hours"> {{hoursToDay}} </span> Hrs
    <span id="minutes"> {{minutesToDay}} </span> Min
    <span id="seconds"> {{secondsToDay}} </span> Sec
</div>
